exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3G2kIknINVLqw2jb1ClLyu{width:max-content;max-width:200px}@media all and (-ms-high-contrast: none), (-ms-high-contrast: active){._3G2kIknINVLqw2jb1ClLyu{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}}@supports (-ms-ime-align: auto){._3G2kIknINVLqw2jb1ClLyu{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}}\n", ""]);

// Exports
exports.locals = {
	"CueTooltip": "_3G2kIknINVLqw2jb1ClLyu"
};